import {Box, styled, SxProps} from "@mui/material";
import DateCard from "../date-card";
import DateRowInfo from "../date-row-info";
import WatchLaterIcon from "@mui/icons-material/WatchLater";
import FmdGoodIcon from "@mui/icons-material/FmdGood";
import theme, {FONTS} from "../../constants/theme";
import {scale} from "../../utils";
import Text from "../text";
import CustomSvg from "../custom-svg";
import {GOCCIA_RIFLESSO} from "../../constants/svgs";
import React from "react";

interface CommonProps {
  dayName: string;
  dayNumber: string;
  month: string;
  year: string;
  colorStyle: 'primary' | 'secondary';
  city: string;
  firstHour?: string;
  secondHour?: string;
  address: string;
  sx?: SxProps;
}

type Props =
  | ({
  isMobile: true;
  type: 'plasma' | 'sangue' | 'plasma & sangue';
} & CommonProps)
  | ({
  isMobile?: false | undefined;
  type?: never;
} & CommonProps);

const Wrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'colorStyle',
})<{ colorStyle: 'primary' | 'secondary' }>(({ colorStyle, theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  width: scale(320),
  height: scale(480),
  gap: scale(15),
  borderRadius: scale(18),
  backgroundColor: colorStyle === 'primary' ? theme.palette.white.main : theme.palette.primary.main,
  [theme.breakpoints.down('sm')]: {
    paddingBottom: scale(50),
  },
}));

const DateDetailedCard = ({dayName, dayNumber, month, year, sx, colorStyle, city, firstHour, secondHour, address, isMobile = false, type}: Props) => {
  return (
    <Wrapper colorStyle={colorStyle} sx={sx}>
      <DateCard dayName={dayName} dayNumber={dayNumber} month={month} year={year} colorStyle={colorStyle} sx={{marginTop: scale(30)}}/>
      <Text
        text={city}
        fontFamily={FONTS.MONTSERRAT}
        color={colorStyle === 'primary' ? theme.palette.text.secondary : theme.palette.text.primary}
        fontSize={scale(28)}
        fontWeight={'bold'}
        lineHeight={scale(34)}
        sx={{ textTransform: 'uppercase', textAlign: 'center' }}
      />
      <Box style={{ display: 'flex', flexDirection: 'column', alignSelf: 'center', gap: scale(10) }}>
        {firstHour && (<DateRowInfo
          IconComponent={WatchLaterIcon}
          firstRowText={firstHour}
          secondRowText={secondHour ?? ''}
          colorStyle={colorStyle}
          sx={{gap: scale(6)}}
          textSx={{
            textAlign: 'center',
            width: scale(150),
            fontFamily: FONTS.MONTSERRAT,
            fontVariantNumeric: 'tabular-nums',
            fontWeight: 500
          }}
        />)}
        <DateRowInfo
          IconComponent={FmdGoodIcon}
          firstRowText={address}
          colorStyle={colorStyle}
          sx={{gap: scale(6)}}
          textSx={{ textTransform: 'capitalize', fontWeight: 500}}
        />
        {isMobile && (
          <Box sx={{display: 'flex', justifyContent: 'center', gap: 0, mx: 'auto', maxWidth: scale(100)}}>
            {(type === 'sangue' || type === 'plasma & sangue') && (<DateRowInfo
              IconComponent={
                <CustomSvg
                  svg={GOCCIA_RIFLESSO}
                  sx={{
                    zIndex: 2,
                    fontSize: scale(36),
                  }}
                  cls1Color={theme.palette.blood.main}
                />
              }
              sx={{marginLeft: type === 'sangue' ? scale(20) : undefined}}
              bgColor={theme.palette.white.main}
              firstRowText={''}
              textSx={{display: 'none'}}
              colorStyle={'primary'}
            />)}
            {(type === 'plasma' || type === 'plasma & sangue') && (<DateRowInfo
              IconComponent={
                <CustomSvg
                  svg={GOCCIA_RIFLESSO}
                  sx={{
                    zIndex: 2,
                    fontSize: scale(36),
                  }}
                  cls1Color={theme.palette.plasma.main}
                />
              }
              sx={{marginLeft: type === 'plasma' ? scale(20) : undefined}}
              bgColor={theme.palette.white.main}
              firstRowText={''}
              textSx={{display: 'none'}}
              colorStyle={'primary'}
            />)}
          </Box>
        )}
      </Box>
    </Wrapper>
  )
}

export default DateDetailedCard
